import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, AuthContext } from '../App';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const JoinPage = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    if (form.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    try {
      const res = await API.post('/auth/register', {
        name: form.name,
        email: form.email,
        password: form.password,
        role: 'parent'
      });
      login(res.data.user, res.data.token);
      toast.success('Welcome to Unbox\'D! Please complete your intake form.');
      navigate('/intake');
    } catch (err) {
      const msg = err.response?.data?.detail || 'Registration failed';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#2c3e50] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white tracking-tight">Unbox'D Autism</h1>
          <p className="text-sm text-gray-300 mt-1 uppercase tracking-widest">Coaching & Consulting</p>
        </div>

        <Card data-testid="join-card" className="border-0 shadow-2xl">
          <CardHeader className="text-center pb-2">
            <CardTitle className="text-2xl">Create Your Account</CardTitle>
            <CardDescription>Welcome! Set up your account to get started.</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="join-name">Full Name</Label>
                <Input
                  id="join-name"
                  data-testid="join-name-input"
                  type="text"
                  placeholder="Your full name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  required
                />
              </div>
              <div>
                <Label htmlFor="join-email">Email</Label>
                <Input
                  id="join-email"
                  data-testid="join-email-input"
                  type="email"
                  placeholder="your@email.com"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                />
              </div>
              <div>
                <Label htmlFor="join-password">Password</Label>
                <Input
                  id="join-password"
                  data-testid="join-password-input"
                  type="password"
                  placeholder="Min 6 characters"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                />
              </div>
              <div>
                <Label htmlFor="join-confirm-password">Confirm Password</Label>
                <Input
                  id="join-confirm-password"
                  data-testid="join-confirm-password-input"
                  type="password"
                  placeholder="Confirm your password"
                  value={form.confirmPassword}
                  onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
                  required
                />
              </div>
              <Button
                type="submit"
                data-testid="join-submit-btn"
                className="w-full bg-[#c8956c] hover:bg-[#b07d5a] text-white"
                disabled={loading}
              >
                {loading ? 'Creating Account...' : 'Get Started'}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-gray-400 text-xs mt-6">
          By creating an account you agree to work with Coach Robin on your child's journey.
        </p>
      </div>
    </div>
  );
};

export default JoinPage;
